import { axiosInstance } from '~/services';

import type { TypePatchUserModifyPasswordParams } from '~/types/auth.types';
import type { TypeErrorResponseData } from '~/types/common.types';

const usePatchUserModifyPassword = () => {
  const endPoint = '/api-owner/user/modify/password';

  const patchUserModifyPassword = async (params: TypePatchUserModifyPasswordParams) => {
    return axiosInstance
      .patch(endPoint, {
        loginId: params.loginId,
        currentPassword: params.currentPassword,
        newPassword: params.newPassword,
      })
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { patchUserModifyPassword };
};

export default usePatchUserModifyPassword;
